import { defaultSearchRows } from '../lib/settings';
import { sortedStringParams } from '../lib/search/getStringSearchParams';
import { CHANGE_LOCALE } from './app';

export const FIELD_IDS = [
  'id',
  'type',
  'version',
  'externalUrl',
  'agencyId',
  'dataflowId',
  'indexationDate',
  'lastUpdated',
  'name',
  'description',
  'dimensions',
  'datasourceId',
  'score',
];

const model = () => ({
  dataflows: [],
  facets: [],
  rows: defaultSearchRows, // number of dataflows per page (search)
  sortParams: sortedStringParams(), // default sort params
});

export const RESET_SEARCH = '@@search/RESET_SEARCH';
export const CHANGE_TERM = '@@search/CHANGE_TERM';
export const CHANGE_CONSTRAINTS = '@@search/CHANGE_CONSTRAINTS';

//-------------------------------------------------------------------------------------------reducer
export default (state = model(), action = {}) => {
  switch (action.type) {
    case RESET_SEARCH:
      return { rows: defaultSearchRows };
    case CHANGE_LOCALE:
      return model();
    default:
      return state;
  }
};
